import { render, staticRenderFns } from "./lymphomap-form.html?vue&type=template&id=964c552a&scoped=true&"
import script from "./lymphomap-form.js?vue&type=script&lang=js&"
export * from "./lymphomap-form.js?vue&type=script&lang=js&"
import style0 from "./lymphomap-form.scss?vue&type=style&index=0&id=964c552a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964c552a",
  null
  
)

export default component.exports